import { OverlayTrigger, Popover } from 'react-bootstrap';
import './HintTooltip.css';

/**
 * Explicação que abre ao passar o mouse ou ao tocar (o gatilho recebe foco).
 *
 * Sem children, o gatilho é o ícone de interrogação de sempre. Com children, o próprio conteúdo
 * vira o gatilho: serve para um selo como "Sem base anterior" se explicar sem um ícone a mais
 * ao lado dele.
 */
const HintTooltip = ({ text, children }) => {
    const popover = (
        <Popover className="hint-popover">
            <Popover.Body>{text}</Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="auto" overlay={popover}>
            <span
                className={children ? 'hint-popover__trigger hint-popover__trigger--content' : 'hint-popover__trigger'}
                role="button"
                tabIndex={0}
                aria-label={text}
            >
                {children || <i className="fa-solid fa-circle-question"></i>}
            </span>
        </OverlayTrigger>
    );
};

export default HintTooltip;
